import { Grid, Stack } from '@mui/material'
import { GItem, GItemContainer, MiddleGItem } from '../components/common/grids'
import { SubTitle } from '../components/common/subTitle'
import { AttentionLabel } from '../components/common/attentionLabel'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { BackButton } from '../components/common/buttons/backButton'
import { Form } from '../components/common/inputs/form'
import { RadioButtonGroup } from '../components/common/inputs/radioButtonGroup'
import { TextBox } from '../components/common/inputs/textBox'
import { DatePicker } from '../components/common/inputs/datePicker'
import { translate } from '../../i18n'
import { yesNo } from '../../containers/common/constant/classification'
import { GetCategoryMstDto } from '../../dataAccess/webApi/dto/categoryMstDto'
import { useAction } from '../../containers/memberModifyChildTreatment/memberModifyChildTreatmentService'

export const MemberModifyChildTreatment = () => {
  const {
    SUB_CATEGORIES,
    formMethods,
    categoryMst,
    onSubmit,
    childrenResultCode,
  } = useAction()
  
  //const treatmentCategory = categoryMst?.find((value) => value.category === CATEGORY_KEY)
  const subCategories = categoryMst?.filter((mst) => SUB_CATEGORIES.includes(mst.category))

  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Grid container>
          <Grid item md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              {subCategories != null && subCategories.length > 0 ?
                (<>
                  <SubTitle title={"治療情報"} />
                  {subCategories && 
                    subCategories.map((obj) => {
                      return (
                        <InputForm categoryMst={obj} key={obj.category} />
                      )
                    })
                  }
                </>)
                :
                (<>
                  {translate('memberModifyChildTreatment.error.noCategoryMst')}
                </>)
              }
            </Stack>
          </Grid>
        </Grid>
        {!!childrenResultCode && (
          <ErrorMessageCard
            messages={[translate(`memberModifyConfirmationChild.error.childrenResultCode${childrenResultCode}`)]}
          />
        )}
        <BottomButtonGroup>
          <ButtonOutlinedWarningL fullWidth type="submit">
            {translate('memberModifyChildTreatment.button.decision')}
          </ButtonOutlinedWarningL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}

interface InputFormProps {
  categoryMst: GetCategoryMstDto
}

/** 各項目の入力フォーム */
const InputForm = (props: InputFormProps) => {
  const { categoryMst } = props

  const render = () => {

    switch(categoryMst.category) {
      case "treatment.appearanceDate":
        /* 日付 */
        if (categoryMst.options == null || categoryMst.options.length === 0) return null
        
        return (
          <GItemContainer xs={12} rowSpacing={1}>
            <MiddleGItem xs={5} sm={2}>
              {categoryMst.required === yesNo.yes && (
                <AttentionLabel>*</AttentionLabel>
              )}
              {categoryMst.altCategoryName ?? categoryMst.name}
            </MiddleGItem>
            <GItem xs={7} sm={10}>
              <DatePicker 
                label={categoryMst.altCategoryName ?? categoryMst.name}
                name={categoryMst.category} 
                required= {categoryMst.required === yesNo.yes}
              />
            </GItem>
          </GItemContainer>
        )
          
      case "treatment.restLevel":
      case "treatment.domesticInfection":
      case "treatment.medicinePrescription":
      case "treatment.medicineOtc":
      case "treatment.prevalentDisease":
        /* ラジオボタン */
        if (categoryMst.options == null || categoryMst.options.length === 0) return null
        
        const labelData = categoryMst.options.map(op => ({ label: op.optionName, value: op.code }))
        return (
          <GItemContainer xs={12} rowSpacing={1}>
            <MiddleGItem xs={5} sm={2}>
              {categoryMst.required === yesNo.yes && (
                <AttentionLabel>*</AttentionLabel>
              )}
              {categoryMst.altCategoryName ?? categoryMst.name}
            </MiddleGItem>
            <GItem xs={7} sm={10}>
              <RadioButtonGroup
                label={categoryMst.altCategoryName ?? categoryMst.name}
                name={categoryMst.category}
                buttonValueLabels={labelData}
                required={categoryMst.required === yesNo.yes}
                row
              />
            </GItem>
          </GItemContainer>
        )
          
      case "treatment.progress":
      case "treatment.medicinePrescriptionNote":
      case "treatment.medicineOtcNote":
      case "treatment.prevalentDiseaseNote":
        /* テキストボックス */
        return (
          <GItemContainer xs={12} rowSpacing={1}>
            <MiddleGItem xs={5} sm={2}>
              <GItemContainer xs={12}>
                <GItem xs={12}>
                  <div>
                    {categoryMst.required === yesNo.yes && (
                      <AttentionLabel>*</AttentionLabel>
                    )}
                    {categoryMst.altCategoryName ?? categoryMst.name}
                  </div>
                  <div>
                    {categoryMst.maxLength != null ? `(${categoryMst.maxLength}字以内)` : ''}
                  </div>
                </GItem>
              </GItemContainer>
            </MiddleGItem>
            <GItem xs={7} sm={10}>
              <TextBox
                label={categoryMst.altCategoryName ?? categoryMst.name}
                name={categoryMst.category}
                maxLength={categoryMst.maxLength}
                rows={4}
                required={categoryMst.required === yesNo.yes}
                multiline
                fullWidth
              />
            </GItem>
          </GItemContainer>
        )
        
      default:
        return null
    }
  }
  
  return (render())
}
